import { getRandomNum, lastSevenDayData } from "@/utils/index.js";

export function workerData() {
  return [
    {
      name: "罐车",
      id: 428,
      value: 96,
    },
    {
      name: "装载车",
      id: 431,
      value: 100,
    },
    {
      name: "自卸汽车",
      id: 431,
      value: 98,
    },
    {
      name: "洒水车",
      id: 431,
      value: 100,
    },
  ];
}

export function ListData() {
  return [
    {
      name: "粤E10000",
      department: "机械班组",
      id: 428,
      dateTime: "2021-01-01 06:00:00",
      status: "进",
    },
    {
      name: "粤E10001",
      department: "机械班组",
      id: 431,
      dateTime: "2021-01-01 10:00:00",
      status: "进",
    },
    {
      name: "粤E100021",
      department: "机械班组",
      id: 431,
      dateTime: "2021-01-01 11:00:00",
      status: "进",
    },
    {
      name: "粤E10000",
      department: "机械班组",
      id: 431,
      dateTime: "2021-01-01 12:00:00",
      status: "出",
    },
  ];
}

export function StatisticsData() {
  let dataDom = [];

  lastSevenDayData().forEach((itemDate) => {
    dataDom.push({
      date: itemDate.startTime,
      value: getRandomNum(0, 40),
    });
  });

  return dataDom;
}
